window.addEventListener( 'load', function() {
	var accordionSections = document.querySelectorAll( '.schema-faq-section,.accordion-simple-section' );

	accordionSections.forEach( function( accordionSection ) {

		accordionSection.setAttribute( 'aria-expanded', 'false' );

		accordionSection.addEventListener( 'click', function( event ) {

			if ( event.target.classList.contains( 'schema-faq-question' ) || event.target.classList.contains( 'accordion-simple-heading' ) ) {

				if ( accordionSection.getAttribute( 'aria-expanded' ) === 'true' ) {
					accordionSection.setAttribute( 'aria-expanded', 'false' );
				} else {
					accordionSection.setAttribute( 'aria-expanded', 'true' );
				}

			}

		} );

	} );
} );
